import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledLast30DaysSpending = styled(Space)`
  align-items: end;
  justify-content: space-between;
  width: 100%;
`;

const StyledLast30DaysSpendingAmount = styled.div`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledLast30DaysSpendingPercentage = styled.div`
  ${typographyStyles.body.medium};
  border-radius: 16px;
  height: 24px;
  padding: 1px 8px;

  &.increase {
    background-color: #FEE4E2;
    color: ${props => props.theme.colors.functional_danger};
  }
  &.decrease {
    background-color: #52C41A33;
    color: ${props => props.theme.colors.functional_success};
  }
`;

export {
  StyledLast30DaysSpending,
  StyledLast30DaysSpendingAmount,
  StyledLast30DaysSpendingPercentage
}
